import React, { useState } from "react";
import { Button } from "reactstrap";
import { GiPadlock } from "react-icons/gi";
import { BiPhoneCall, BiUser, BiEnvelope } from "react-icons/bi";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import "./style.css";
import { useNavigate } from "react-router";
import logo from "../assets/img/logo.jpg";
import { toast } from "react-toastify";
import { postDataNoData } from "../api/method";

function Register() {
  const phoneRegExp = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  const emailRegExp =
    /^[a-z][a-z0-9_\.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/;
  const nameRegExp = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
  const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
  const usernameRegExp = /^[a-z0-9_-]{3,16}$/;

  const today = new Date(),
    getDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

  const [error, setError] = useState({});
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [admin, setAdmin] = useState(0);
  const [created, setCreated] = useState(getDate);
  const [actived, setActived] = useState(1);

  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const togglePassword2 = () => {
    setPasswordShown2(!passwordShown2);
  };

  const navigate = useNavigate();

  const validation = (e) => {
    const msg = {};

    if (firstname === "") {
      msg.firstname = "First name is requied!";
    } else if (!firstname.match(nameRegExp)) {
      msg.firstname = "First name is valid. Not number!";
    }

    if (lastname === "") {
      msg.lastname = "Last name is requied!";
    } else if (!lastname.match(nameRegExp)) {
      msg.lastname = "Last name is valid. Not number!";
    }

    if (phone === "") {
      msg.phone = "Phone is requied!";
    } else if (!phone.match(phoneRegExp)) {
      msg.phone = "Phone is valid. Start 84-03-05-07-08-06-09!";
    }

    if (email === "") {
      msg.email = "Email is requied!";
    } else if (!email.match(emailRegExp)) {
      msg.email = "Email is valid!";
    }

    if (username === "") {
      msg.username = "Username is requied!";
    } else if (!username.match(usernameRegExp)) {
      msg.username =
        "Username is valid. Username should be at least 3 charcters long!";
    }

    if (password === "") {
      msg.password = "Password is requied!";
    } else if (!password.match(passwordRegExp)) {
      msg.password =
        "Password should be at least 6 charcters long, at least one letter and one number!";
    }

    if (confirmPassword === "") {
      msg.confirmPassword = "Confirm Password is requied!";
    } else if (!confirmPassword.match(passwordRegExp)) {
      msg.confirmPassword =
        "Password should be at least 6 charcters long, at least one letter and one number!";
    } else if (confirmPassword !== password) {
      msg.confirmPassword = "Password does not match!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const handleSubmitRegister = async () => {
    const isValid = validation();
    const formData = new FormData();

    if (isValid) {
      formData.append("username", username);
      formData.append("password", password);
      formData.append("firstname", firstname);
      formData.append("lastname", lastname);
      formData.append("phone", phone);
      formData.append("email", email);
      formData.append("admin", 0);
      formData.append("created", created);
      formData.append("actived", 1);

      try {
        const res = await postDataNoData("/api/Register", formData);
        if (res.status === 200) {
          toast.success("Register success!");
          navigate("/login");
        }
      } catch (err) {
        console.log(err);
        toast.error("Register fail!");
      }
    }
  };

  return (
    <div className="form_login_register d-flex align-items-center justify-content-center">
      <div className="w-25">
        <img src={logo} alt="logo" width="100%" />
      </div>

      <div className="w-25 ms-5">
        <h3 className="fs-1 fw-bold text-center mb-5">Register</h3>

        <div className="d-flex align-items-center line_border--nr">
          <BiUser className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Last Name"
            type="text"
            onChange={(e) => setLastname(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.lastname && <p className="error text-start">{error.lastname}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <BiUser className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="First Name"
            type="text"
            onChange={(e) => setFirstname(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.firstname && (
          <p className="error text-start">{error.firstname}</p>
        )}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <BiPhoneCall className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Phone"
            type="number"
            onChange={(e) => setPhone(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.phone && <p className="error text-start">{error.phone}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <BiEnvelope className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Email"
            type="text"
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.email && <p className="error text-start">{error.email}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <BiUser className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Username"
            type="text"
            onChange={(e) => setUsername(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>

        {error.username && <p className="error text-start">{error.username}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <GiPadlock className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Password"
            type={passwordShown ? "text" : "password"}
            onChange={(e) => setPassword(e.target.value)}
            onKeyUp={handleKeyUp}
          />
          {passwordShown === true ? (
            <AiOutlineEye
              className="fs-5 cursor_pointer"
              onClick={togglePassword}
            />
          ) : (
            <AiOutlineEyeInvisible
              className="fs-5 cursor_pointer"
              onClick={togglePassword}
            />
          )}
        </div>

        {error.password && <p className="error text-start">{error.password}</p>}

        <div className="d-flex align-items-center line_border--nr mt-2">
          <GiPadlock className="fs-4 pe-1" />
          <input
            className="fs-6 border-0"
            placeholder="Confirm Password"
            type={passwordShown2 ? "text" : "password"}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onKeyUp={handleKeyUp}
          />
          {passwordShown2 === true ? (
            <AiOutlineEye
              className="fs-5 cursor_pointer"
              onClick={togglePassword2}
            />
          ) : (
            <AiOutlineEyeInvisible
              className="fs-5 cursor_pointer"
              onClick={togglePassword2}
            />
          )}
        </div>

        {error.confirmPassword && (
          <p className="error text-start">{error.confirmPassword}</p>
        )}

        <div className="d-flex justify-content-center">
          <Button
            className="btn_custom mt-5"
            onClick={() => handleSubmitRegister()}
          >
            Register
          </Button>
        </div>

        <div className="no_account text-center mt-4">
          Already have an account?{" "}
          <span
            className="ms-2 cursor_pointer t-primary fw-bold"
            onClick={() => navigate("/login")}
          >
            Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default Register;
